import './Header.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Icon from '@mdi/react';
import Image from 'react-bootstrap/Image';
import mainLogo from './mainLogo.png'
import { mdiAccount, mdiCameraIris, mdiFacebook, mdiGithub, mdiInstagram, mdiLinkedin, mdiNoodles } from '@mdi/js';
import axios from "axios";
import React from 'react';


export default class Header extends React.Component {
  state = {
    sections: [],
    socials: []
  }
  icons = {
    "mdiAccount":mdiAccount,
    "mdiCameraIris":mdiCameraIris,
    "mdiNoodles":mdiNoodles,
    "mdiFacebook":mdiFacebook,
    "mdiGithub":mdiGithub,
    "mdiInstagram":mdiInstagram,
    "mdiLinkedin":mdiLinkedin
  }
  

  componentDidMount() {
    const apiToken= process.env.REACT_APP_IARENAS_TOKEN;
    const getSectionsAPI='https://rg24xdvhj6.execute-api.us-east-1.amazonaws.com/default/iarenas-getSections'
    axios.post(
    getSectionsAPI,
    {'type':'section' },
    {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiToken
      }
      }).then(res => {
        const sections = res.data;
        this.setState({ sections });
        
      })
      axios.post(
        getSectionsAPI,
        {'type':'social' },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiToken
          }
          }).then(res => {
            const socials = res.data;
            this.setState({ socials });
          })
  }


  render() {
    return (
      <Container fluid className="Navigator">
        <Row className='menuRow'>
          <Col xs={4} md={4} lg={4} className="mainLogo"> 
            <Col md={12}  className="mainLogo"> 
              <a href="/" className="Navi" rel="noopener noreferrer"> 
                <Image src={mainLogo} className = "mainLogo" />             
              </a> 
            </Col>
          </Col> 
          <Col xs={8} md={4} className="d-none d-lg-block" > 
            <Row>    
            {
            this.state.sections.map(section =>
                <Col key={section.section} className = "MenuColumn">
                  <a href={section.route} rel="noopener noreferrer"> 
                    <div  className='Navi'> <Icon path={this.icons[section.mdiIcon]} className='icons'/><br/>{section.section.toUpperCase()}</div>
                  </a>
                </Col>
              
            )}
            </Row>
          </Col>
          <Col xs={2} md={4} lg={2} className="mainLogo d-block d-lg-none"/> 
          <Col className="socialMenu">
            <Row className='menuRow '>
              <Col xs={4} sm={4} md={4} lg={8} xl={8} className=" mainLogo"/> 
              {
                this.state.socials.map(social =>
                <Col xs={2} md={2} lg={1} key={social.section}>
                  <a href={social.route} target="_blank" rel="noopener noreferrer"> 
                    <Icon path={this.icons[social.mdiIcon]} className='social icons'/>
                  </a>
                </Col>
              )}  
            </Row>
          </Col>
        </Row>
      </Container>
    );
  }
}
